// const auctionContractAddress = "0x9773e24ee10be2CA9D6F068DC5F461aE26636Ed1"// normal Auction testnet
const auctionContractAddress = "0xA5F8468c8eBe578eceF04bDB44cbc0C6F0bFFa74"//normal auction mainnet
export default auctionContractAddress